//BuyerszonePaintingImage
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getMethod } from '../../../services/apiService';
import { IMG_URL } from '../../../utility/config';
import LoadingSpinner from '../../../utility/LoadingSpinner';

function PaintingImagePage() {
    const { id } = useParams();
    const [painting, setPainting] = useState(null);
    const [loading, setLoading] = useState(true);
    const IMG_BASE_URL = IMG_URL

    //Display painting
    useEffect(() => {
        const fetchPainting = async () => {
            const response = await getMethod(`paintings/${id}`);
            if (response && response.status) {
                setPainting(response.data);
            } else {
                console.error('Failed to fetch painting by ID:', response.error || response);
            }
            setLoading(false);
        };

        fetchPainting();
    }, [id]);

    if (loading) return <LoadingSpinner/>;

    if (!painting) return <p>Painting not found.</p>;
    
    return (
        <div style={{ textAlign: 'center' }}>
            <h2 dangerouslySetInnerHTML={{ __html: painting.title }}/>
            <img
                src={`${IMG_BASE_URL}/${painting.image_url}`}
                alt={painting.title}
                style={{ width: '100%' }}
            />


            <p dangerouslySetInnerHTML={{ __html: painting.long_description }} />
        </div>
    );
}

export default PaintingImagePage;